import { CloseOutlined } from "@ant-design/icons";
import { Modal, DatePicker, Form, message, Button } from "antd";
import { useEffect, useState } from "react";
import { serverFetch } from "../../server";
import { isMobile } from "../../extensions/design";
import dayjs from "dayjs";
import { strDate2Server } from "../../extensions/utils"
import { CLIENT_NESTED_ANTD_MODAL_Z_INDEX } from "./client-nested-modal-zindex";

const ActivateModal = ({ onClose, saleId }) => {
  const [form] = Form.useForm();
  const [date, setDate] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const today = dayjs();
    setDate(today);
    form.setFieldsValue({ dateStart: today });
  }, []);

  const onStatusActive = () => {
    const values = form.getFieldsValue();
    const dateStr = strDate2Server(values.dateStart);
    setLoading(true);
    const bodyData = Array.isArray(saleId)
      ? { saleIds: saleId, date: dateStr }
      : { saleId, date: dateStr };
    serverFetch("sale/SetActivated", {
      method: "POST",
      bodyData,
    })
      .then((res) => {
        setLoading(false);
        const payload = res?.errors ?? res?.results ?? res;
        onClose(true, payload);
      })
      .catch((e) => {
        setLoading(false);
        message.error(e.userMessage);
      });
  };

  return !isMobile ?
    <Modal
      title="Активировать абонемент"
      open
      zIndex={CLIENT_NESTED_ANTD_MODAL_Z_INDEX}
      onCancel={() => onClose(false)}
      onOk={onStatusActive}
      okText="Сохранить"
      cancelText="Закрыть"
      width={400}
    >
      <Form form={form} colon={false}>
        <Form.Item label="Дата активации" name="dateStart">
          <DatePicker
            value={date}
            onChange={(date) => {
              setDate(date);
              form.setFieldsValue({ dateStart: date });
            }}
            style={{ width: "100%" }}
            format="DD.MM.YYYY"
          />
        </Form.Item>
      </Form>
    </Modal>
  : <div className="sport-modal">
  <div className="sport-modal-overlay">
    <div className="sport-modal-content">
      <div className="sport-modal-title">
        <span>Активировать абонемент</span>
        <CloseOutlined onClick={() => onClose(false)} className="sport-section-title-close client-close-outlined-button-style"/>
      </div>
      <Form form={form} labelCol={{ xs: 9}} wrapperCol={{ xs: 15}} colon={false} layout="inline">
          <Form.Item label="Дата активации" name="dateStart" className="client-activate-abon-modal-form-item client-abon-form-item">
              <DatePicker format="DD.MM.YYYY" value={date} className="client-abon-form-item"
                onChange={(date) => {
                  setDate(date);
                  form.setFieldsValue({ dateStart: date });
                }}
              />
          </Form.Item>
          <Button className="client-abon-form-item-with-margin" onClick={onStatusActive}>Сохранить</Button>
        </Form>
      </div>
    </div>
  </div>
};

export default ActivateModal;
